<div>
	{{ value ? value.name : null }}
</div>
